module.exports = __webpack_public_path__ + "img/login-ecshopx.44ac360b.jpg";